import { Navigate, useLocation } from 'react-router-dom';
import { readTenantPath, rememberTenant } from '../tenantPath';

/**
 * The client-scoped entry point: {@code /t/<slug>/...}.
 *
 * <p>Records which client's address was followed and continues to the ordinary route, which signs
 * the visitor in exactly as the bare address does. The slug is not yet doing any work beyond being
 * remembered — realms arrive in ADR 0006 step 2 — and that is the honest state of it. What it is
 * not is a blank page, which is what this address rendered before the route existed.
 */
export function TenantEntry() {
  const location = useLocation();
  const tenant = readTenantPath(location.pathname);
  if (tenant) {
    rememberTenant(tenant.slug);
    // The fragment too: it is where the workbench keeps the open case and tab, and a client's
    // deep link (`/t/pilot/workbench#/case/<id>/financials/quote`) that lost it here landed on
    // the board - straight after sign-in, when the return path is replayed through this route.
    return <Navigate to={tenant.rest + location.search + location.hash} replace />;
  }
  // A malformed slug is a typo or a probe. Both are better served by the ordinary sign-in than by
  // a page that pretends a client called "QBE!" exists.
  return <Navigate to="/" replace />;
}
